import React from 'react'
import { Route, Switch } from 'react-router'
import ReportVehicleFuelings from './ReportVehicleFuelings'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportVehicleFuelings} />
    </Switch>
)

export default Components
